$(document).on('submit', 'form', function() {
    $('#loading').show();
});

$(document).on('click', 'a, button', function(event) {
    // Evitar mostrar loading al hacer clic en:
    // - Enlaces que abren en nueva pestaña
    // - Botones dentro del mapa (map-button)
    // - Marcadores del mapa (leaflet-marker-icon)
    // - Botones para cerrar ventanas emergentes (close-popup)
    if (!event.metaKey && !event.ctrlKey &&
        !$(event.target).closest('.leaflet-marker-icon, .skip-loading, .nav-item').length) {
        $('#loading').show();
    }

    if (!event.metaKey && !event.ctrlKey &&
        $(event.target).closest('.close-popup, .leaflet-popup-close-button, .skip-loading').length) {
        $('#loading').hide();
    }
});

$(window).on('load', function() {
    $('#loading').hide();
});

$(document).on('turbo:visit', function() {
    $('#loading').show();
});

$(document).on('turbo:load', function() {
    $('#loading').hide();
});

document.addEventListener("turbolinks:request-start", function() {
    $('#loading').show(); // Muestra el loading al iniciar una solicitud de Turbolinks
});

document.addEventListener("turbolinks:before-cache", function() {
    $('#loading').hide(); // Asegúrate de ocultar el loading antes de almacenar en caché la página
});

// Manejo de la navegación con el botón atrás/adelante
window.addEventListener('popstate', function() {
    $('#loading').hide(); // Ocultar el loading al usar el botón de atrás o adelante
});

$(document).on('click', 'a.map-link', function(event) {
    $('#loading').show();  // Muestra el loading al hacer clic en el enlace del mapa
});